import { Shark, View } from "shark-mvc";

import templateContent from "../../_shark_templates/views/applicator-team-edit.html";

import applicatorTeamListView from "./applicatorTeamListView";
import applicatorTeamManager from "../managers/applicatorTeamManager";
import mainNavComponent from "../components/mainNavComponent";
import teamUpManager from "../managers/teamUpManager";

class ApplicatorTeamEditView extends View {
	nameCheckInProgress = false;

	constructor () {
		super("applicatorTeamEditView");

		this.setTemplate(templateContent);
	}

	afterLoad () {
		if (!Shark.get("currApplicatorTeam")) {
			Shark.openPage(applicatorTeamListView);
		}
	}

	backToListBtn_clickHandler () {
		this.cancelEdits(true);
	}

	beforeLoad () {    
		window.scrollTo(0, 0);
	}
	
	cancelEdits (forceBackToList = false) {
		const { currApplicatorTeam } = Shark.get();
	
		if (!currApplicatorTeam.isDirty() || confirm("Sei sicuro di voler annullare le modifiche apportate?")) {
			currApplicatorTeam.restore();
	
			this.disableEdits();

			if (currApplicatorTeam.guid === "" || forceBackToList) {
				Shark.openPage(applicatorTeamListView);
			}
		}
	}

	cancelEditsBtn_clickHandler () {
		this.cancelEdits();
	}

	disableEdits () {
		Shark.set({
			isEditingApplicatorTeam: false,
		});
	}

	enableEdits () {
		Shark.set({
			isEditingApplicatorTeam: true,
		});
	}

	editItemBtn_clickHandler () {
		this.enableEdits();
	}

	getSubCalendarId (sourceRequest) {
		return new Promise((resolve) => {
			if (this.nameCheckInProgress) {
				resolve(false);
			}
			else {
				this.nameCheckInProgress = true;
				const currApplicatorTeam = Shark.get("currApplicatorTeam");

				if (currApplicatorTeam.name.trim() !== "") {
					teamUpManager.getSubCalendarFromName(currApplicatorTeam.name)
					.then(getSubCalendarFromNameResponse => {
						this.nameCheckInProgress = false;

						switch (getSubCalendarFromNameResponse.data.length) {
							case 1: {
								const subCalendar = getSubCalendarFromNameResponse.data[0];

								if (confirm(`Ho trovato "${subCalendar.name}" cercando su TeamUp, corrisponde alla Squadra che vuoi inserire?`)) {
									currApplicatorTeam.set("subCalendarId", subCalendar.id);
								}

								resolve(true);
								break;
							}
							case 0:
								if (sourceRequest !== "save" || (sourceRequest === "save" && currApplicatorTeam.extraData.enabled === true)) {
									alert("Attenzione, il nome inserito non corrisponde ad alcuna Squadra su TeamUp, per favore prima di inserire la squadra su IPM HUB crea il calendario relativo su TeamUp.\n\nSe il caledario è già stato creato verifica di aver digitato correttamente il nome.\n\nSe vuoi comunque salvare senza correggere, per favore segna la Squadra come NON attiva.");
									currApplicatorTeam.set("subCalendarId", "");

									resolve(false);
								}
								else {
									resolve(true);
								}
								break;
							default:
								if (sourceRequest !== "save" || (sourceRequest === "save" && currApplicatorTeam.extraData.enabled === true)) {
									alert("Attenzione, il nome inserito corrisponde a più Squadre su TeamUp, per favore scrivi il nome completo in modo da identificarne solo una. Se non puo risolvere questo problema contatta il supporto tecnico.\n\nSe vuoi comunque salvare senza correggere, per favore segna la Squadra come NON attiva.");
									currApplicatorTeam.set("subCalendarId", "");

									resolve(false);
								}
								else {
									resolve(true);
								}
								break;
						}
					});
				}
			}
		});
	}
	
	init () {
		this.addComponents([mainNavComponent]);
		this.disableEdits();
	}

	nameField_blurHandler () {
		this.getSubCalendarId();
	}

	saveItemBtn_clickHandler () {
		this.getSubCalendarId("save")
		.then(response => {
			const currApplicatorTeam = Shark.get("currApplicatorTeam");

			if (response || currApplicatorTeam.extraData.enabled === false) {
				applicatorTeamManager.save(currApplicatorTeam)
				.then(() => {
					Shark.set("isEditingApplicatorTeam", false);
					Shark.openPage(applicatorTeamListView);
				});
			}
		});
	}
}

const applicatorTeamEditView = new ApplicatorTeamEditView();

Shark.registerView(applicatorTeamEditView);

export default applicatorTeamEditView;
